import logo2022_2023 from "../../assets/img/nxtEvents/LogoDeadl1ne/Deadl1ne2022-2023.png";
import logo2024 from "../../assets/img/nxtEvents/LogoDeadl1ne/Deadl1ne2024.png";
import logo2025 from "../../assets/img/nxtEvents/LogoDeadl1ne/Deadl1ne2025.png";

export const nxtDeadlineDetail = {
  "nxt-deadline": {
    id: "nxt-deadline",
    title: "NXT Deadline",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-deadline",
        items: [
          {
            id: "nxt-deadline-2022",
            title: "Deadl1ne",
            description: "2022 - 2023",
            imgUrl: logo2022_2023,
          },
          {
            id: "nxt-deadline-2024",
            title: "Deadl1ne",
            description: "2024",
            imgUrl: logo2024,
          },
          {
            id: "nxt-deadline-2025",
            title: "Deadl1ne",
            description: "2025",
            imgUrl: logo2025,
          },
        ],
      },
    ],
  },
};
